class archiveTemplate {
    constructor($injector) {
        this.alert = $injector.get('Alert');
        this.api = $injector.get('$http');
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');

        this.key = 'archive-template';
        this.title = this.translate.instant('templates.workflows.details.archive-template.title');
        this.level = 'highlight';
        this.icon = 'fal fa-trash-alt';

        this.order = 50;
    }

    /**
     * @todo translate and rework
     * @param template
     * @param vm
     */
    action(template, vm) {
        this.alert.confirm({
            title: `Deleting ${template.name}`,
            message: 'Are you sure you want to move this template to trash?',
            confirmBtn: 'Delete'
        }).then(() => {
            return this.api.put(`templates/${template.id}/archive`)
                .then(() => {
                    this.state.reload();
                    if (vm.store) {
                        return vm.store.dispatch('getData');
                    }
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.modules.templates')
    .factory('archiveTemplate', [
        '$injector',
        ($injector) => new archiveTemplate($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/templates/workflows/details/archive-template.js